import { LLMClassifierImplementation } from "models/LLMs/LLMClassifierImplementation";
import { LLMClassifierBuilderStore } from "../Stores/LLMClassifierBuilderStore";
import { action, makeObservable, observable, toJS } from "mobx";
import { Condition } from "models/LLMs";
import { LLMClassifierImplementationConfigurationBase } from "models/LLMs/LLMClassifierImplementation";
import { deepCamelCase, deepPascalCase } from "../utils";

export interface ILLMClassifierConfigurationBuilder {
    executeConditions: Condition[];
    addExecuteCondition(condition: Condition): void;
    removeExecuteCondition(condition: Condition): void;

    isTestable(store?: LLMClassifierBuilderStore): boolean;
    isSavable(): boolean;
    getConfiguration(): LLMClassifierImplementation["configuration"];
}

export abstract class LLMClassifierConfigurationBuilder
    implements ILLMClassifierConfigurationBuilder
{
    @observable public executeConditions: Condition[];

    constructor(configuration?: LLMClassifierImplementationConfigurationBase) {
        makeObservable(this);

        this.executeConditions = observable.array();
        const camelized = configuration
            ? deepCamelCase(configuration)
            : undefined;
        if (camelized && Array.isArray(camelized.executeConditions)) {
            this.executeConditions = observable.array(
                camelized.executeConditions.map(
                    Condition.ResolveConcreteCondition,
                ),
            );
        }
    }

    isTestable(): boolean {
        return true;
    }
    isSavable(): boolean {
        return true;
    }
    getConfiguration(): LLMClassifierImplementation["configuration"] {
        const executeConditions = toJS(this.executeConditions);
        return {
            executeConditions: deepPascalCase(executeConditions),
            executeConditionsV2: deepPascalCase(executeConditions),
        } as LLMClassifierImplementation["configuration"];
    }

    @action
    public addExecuteCondition(condition: Condition) {
        this.executeConditions.push(condition);
    }

    @action
    public removeExecuteCondition(condition: Condition) {
        const index = this.executeConditions.indexOf(condition);
        if (index < 0) return false;
        this.executeConditions.splice(index, 1);
        return true;
    }
}
